export enum AccessTypeEnum {
    Read_View = 1,
    Write_Change = 2,
    Execute_Use = 4,
    Manual_Edit = 8,
    Live_Data = 16,
    Control = 32,
    Disable = 64,
    Advanced_Configuration = 128,
    See_Name = 256,
    See_Comm_Endpoint_Info = 512
}
